import { Sparkle } from "lucide-react";

const WORDS = [
  "Pollo Guisado",
  "Chicken & Rice",
  "Empanadas",
  "Pollo Horneado",
  "Rice with Gandules",
  "Tostones",
  "Maduros",
  "Parcha",
  "Morisoñando",
];

export const Marquee = ({ className = "" }) => (
  <div className={`relative overflow-hidden border-y border-cocoa/15 bg-mango py-6 ${className}`} data-testid="dish-marquee">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {WORDS.map((w) => (
            <span key={w + k} className="flex items-center">
              <span className="px-8 font-display text-4xl italic text-cocoa sm:text-6xl">{w}</span>
              <Sparkle className="h-6 w-6 text-hibiscus" fill="currentColor" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
